import { useHistory, useLocation } from 'react-router'
import * as PropTypes from 'prop-types'
import { HOME_URL, SIGNIN_URL } from 'constants/urls'
import { useContext } from 'react'
import { RootStoreContext } from 'store/rootStore'

/**
 * Returns functions work with locations.
 *  - goTo("/home")
 *  @description Pushing to next page and save Prev page
 *   - push("/home")
 *  @description Pushing to next page
 *  - setLastVisit("/home")
 *  @description Setting last page.
 *  - setPrevPage("/home")
 *  @description Setting previous page.
 *  - goPrevPage()
 *  @description Return to previous page.
 *  - prevPage
 *  @description Return previous page
 *  - lastVisit
 *  @description Return previous page
 * - isReloadedPage()
 *  @description Return true or false
 *  - unAuthByStatus(401)
 *  @description Return to signIn if status(401).
 *
 */

const useRoutes = () => {
	const { authStore } = useContext(RootStoreContext)
	const history = useHistory()
	const location = useLocation()
	/**{(string|null)}
	 * Return last visit page "/url"
	 * or Null.
	 */
	const lastVisit = sessionStorage.getItem('lastVisit')

	/**{(string|null)}
	 * Return previous page "/url"
	 * or Null.
	 */
	const prevPage = sessionStorage.getItem('prevPage')

	/**
	 * @function setLastVisit
	 * Setting last page.
	 *
	 * @param {string} path is the url.
	 * @example setLastVisit("/home")
	 */
	const setLastVisit = path => {
		sessionStorage.setItem('lastVisit', path)
	}
	setLastVisit.propTypes = {
		path: PropTypes.string.isRequired
	}

	/**
	 * @function setPrevPage
	 * Setting previous page.
	 *
	 * @param {string} path is the url .
	 * @example setPrevPage("/home")
	 */
	const setPrevPage = path => {
		sessionStorage.setItem('prevPage', path)
	}
	setPrevPage.propTypes = {
		path: PropTypes.string.isRequired
	}
	/**@function goTo
	 * Pushing to next page
	 * and save previous page.
	 * @param {string} path is the url.
	 * @example goTo("/home")
	 */
	const goTo = path => {
		setPrevPage(location.pathname)
		history.push(path)
	}

	goTo.propTypes = {
		path: PropTypes.string.isRequired
	}

	/**@function push
	 * Pushing to next page
	 * @param {string} path is the url.
	 * @example push("/home")
	 */
	const push = path => {
		history.push(path)
	}

	push.propTypes = {
		path: PropTypes.string.isRequired
	}
	/**
	 * @function goPrevPage
	 * Return to previous page.
	 *  @example goPrevPage()
	 */
	const goPrevPage = () => {
		const last = sessionStorage.getItem('lastVisit')
		const prev = sessionStorage.getItem('prevPage')
		const path =
			last && prev
				? last.toString() === prev.toString()
					? HOME_URL
					: prev.toString()
				: HOME_URL
		goTo(path)
	}

	/**
	 * @function unAuthByStatus
	 * @param {(string|number)} status 401
	 * Return to signIn.
	 *  @example unAuthByStatus(401)
	 */
	const unAuthByStatus = status => {
		if (status && (Number(status) === 401 || Number(status) === 403)) {
			localStorage.removeItem('token')
			authStore.clearAuth()
			return goTo(SIGNIN_URL)
		}
		return true
	}
	/**
	 * @function isReloadedPage
	 * Return  isReloadedPage ?.
	 *  @example isReloadedPage()
	 */
	const isReloadedPage = () => {
		let prev = sessionStorage.getItem('prevPage')
		return location.pathname === prev.toString()
	}
	return {
		goTo,
		setLastVisit,
		setPrevPage,
		goPrevPage,
		push,
		unAuthByStatus,
		isReloadedPage,
		prevPage,
		lastVisit
	}
}
export default useRoutes
